import {
  hasBrowserSupabaseConfig,
  loadFrontendEnv,
  loadServerEnv
} from "./chunk-BVWJDMOD.mjs";

// src/supabase/client.ts
import { createClient } from "@supabase/supabase-js";
function createBrowserClient() {
  const env = loadFrontendEnv();
  if (!env.VITE_SUPABASE_URL || !env.VITE_SUPABASE_ANON_KEY) {
    throw new Error(
      "[Square Code] Cannot create Supabase client \u2014 VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are required.\nSet them in .env.local or Vercel environment variables."
    );
  }
  return createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY);
}
function tryCreateBrowserClient() {
  if (!hasBrowserSupabaseConfig()) return null;
  try {
    return createBrowserClient();
  } catch {
    return null;
  }
}
function createServiceClient() {
  const env = loadServerEnv();
  if (!env.VITE_SUPABASE_URL || !env.SUPABASE_SERVICE_ROLE_KEY) {
    throw new Error(
      "[Square Code] Cannot create service client \u2014 SUPABASE_SERVICE_ROLE_KEY is required.\nThis key must never be exposed to frontend code."
    );
  }
  return createClient(env.VITE_SUPABASE_URL, env.SUPABASE_SERVICE_ROLE_KEY, {
    auth: {
      autoRefreshToken: false,
      persistSession: false
    }
  });
}

export {
  createBrowserClient,
  tryCreateBrowserClient,
  createServiceClient
};
